<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="1000px" class="partShipment" @open="open">
      <div slot="title" class="header-title">
        <span>查看分批发货</span>
        <span style="color:red;margin-left:10px">
          <span>(</span>
          <span>{{ title }}</span>
          <span>)</span>
        </span>
      </div>
      <p>产品信息</p>
      <el-table v-loading="loading" :data="tableData" border style="width: 100%;margin-top:10px;margin-bottom:10px" show-summary
                :summary-method="getSummaries"
      >
        <el-table-column prop="itemIndex" width="50" label="序号" align="left" />
        <el-table-column prop="contractNum" label="合同号" align="left" width="170" />
        <el-table-column prop="materialNumber" label="物品代码" align="left" />
        <el-table-column prop="productName" label="物品名称" align="left" />
        <el-table-column prop="productNum" label="数量" align="left" width="70" />
        <!-- <el-table-column prop="productPriceSigle" label="实际结算单价" align="left" width="80" />
        <el-table-column prop="settlementAmount" label="实际结算金额" align="left" /> -->
        <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" align="left" width="150" />
        <el-table-column prop="agreedDate" label="约定交付日期" align="left" width="150" />
      </el-table>
      <div>
        <p style="font-size:16px;font-weight:800;margin: 10px 0;">
          原信息
        </p>
        <p>
          <span>收货地址：</span>
          <span>{{ applyGoodsBaseInfo.primaryReceiptAddress }}</span>
        </p>
        <p>
          <span>运输方式：</span>
          <span>{{ applyGoodsBaseInfo.primaryModelOfShipping }}</span>
          <span style="margin-left:20px">承运商：</span>
          <span>{{ applyGoodsBaseInfo.primaryCarrier }}</span>
        </p>
      </div>
      <div>
        <p style="font-size:16px;font-weight:800;margin: 10px 0;">
          变更后信息
        </p>
        <p>
          <span>变更后收货地址：</span>
          <span>{{ applyGoodsBaseInfo.receiptAddress.receiverName }}</span>
          <span>{{ applyGoodsBaseInfo.receiptAddress.province }}</span>
          <span>{{ applyGoodsBaseInfo.receiptAddress.city }}</span>
          <span>{{ applyGoodsBaseInfo.receiptAddress.county }}</span>
          <span>{{ applyGoodsBaseInfo.receiptAddress.receiptAddress }}</span>
          <span>{{ applyGoodsBaseInfo.receiptAddress.receiverPhone }}</span>
        </p>
        <p>
          <span>变更后运输方式：</span>
          <span class="rj-baseinfo__item">
            {{ applyGoodsBaseInfo.modeOfShipping }}
          </span>
          <span>变更后承运商：</span>
          <span>
            {{ applyGoodsBaseInfo.carrier }}
          </span>
        </p>
        <p>
          <span>运费差价：{{ applyGoodsBaseInfo.freight }}元</span>
          <!-- <span class="rj-baseinfo__label">运费支付方式：</span> -->

          <!-- <span class="rj-baseinfo__item"> -->
          <!-- <el-radio-group v-model="form.isRebate" @change="changisRebate">
            <el-radio :label="false">现金</el-radio>
            <el-radio :label="true">返利</el-radio>
          </el-radio-group> -->
          <!-- {{ applyGoodsBaseInfo.freightPayTypeStr }}
          </span> -->
        </p>
        <p>
          <span>价外费用合同号： {{ applyGoodsBaseInfo.freightContractNum }}</span>
          <span>价外费用合同分配金额/比例：{{ applyGoodsBaseInfo.freightProportion }}</span>
        </p>
      </div>
      <p>
        <span>唛头单号:</span>
        <span>{{ applyGoodsBaseInfo.marksNum }}</span>
      </p>
      <p>
        <span>收货回执及到货验收要求：</span>
        <span>
          {{ applyGoodsBaseInfo.receiptArrivalAcceptanceRequirements }}
        </span>
      </p>
      <p>
        <span>发货备注说明：</span>
        <span>
          {{ applyGoodsBaseInfo.deliverRemark }}
        </span>
      </p>
      <p>
        <span>回执附件：</span><br>
        <span v-for="(item,index) in fileList" :key="index">
          <el-link :underline="false" style="color:#409EFF" @click="fileClick(item)">{{ item.fileName }}</el-link>
        </span><br>
      </p>
      <p>
        <span>备注：</span>
        <span>
          {{ applyGoodsBaseInfo.remark }}
        </span>
      </p>
      <p style="font-size:16px;font-weight:800;margin: 10px 0;">
        历史审批意见
      </p>
      <el-table :data="tableDataHistory" border style="width: 100%;margin-top:10px;margin-bottom:10px">
        <el-table-column prop="approveUserInfo" label="审批人" align="left" width="170" />
        <el-table-column prop="approveComment" label="审批内容" align="left" />
        <el-table-column prop="approveTime" label="审批时间" align="left" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="handelClose">关 闭</el-button>
      </span>
    </el-dialog>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>
<script type="es6">
import { partialInvoiceDetail, getApproveLogByPartialId, getReceiptAttachmentByPartialShipmentNum, attachmentGetToken } from '@/API';
import { MathAdd } from '@/libs/util';
export default {
  data () {
    return {
      title: '',
      tableData: [],
      tableDataHistory: [],
      dialogVisible: this.dialogFormVisible,
      loading: false,
      showAddress: false,
      isair: false,
      form: {
        isRebate: false,
        rebateAmount: ''
      },

      applyGoodsBaseInfo: {
        primaryReceiptAddress: '',
        primaryModelOfShipping: '',
        primaryCarrier: '',
        receiptAddress: '',
        modeOfShipping: '',
        carrier: '',
        freight: '',
        freightPayTypeStr: '',
        freightContractNum: '',
        freightProportion: '',
        marksNum: '',
        authorizationEmail: '',
        receiptArrivalAcceptanceRequirements: '',
        deliverRemark: '',
        change: '',
        remark: ''
      },
      listNumber: '',
      changeBussiness: '',
      changeBussinessOptions: ['默认物流', '顺丰'],
      goodsReceipt: '',
      goodsRemark: '',
      remark: '',
      dialogNode: {
        is: '',
        allow: this.allowUserRate,
        availableRebateAmount: 0,
        rebateUsedList: []
      },
      fileList: [],
      token: '',
      uploadUrl: '',
      downFileUrl: '',
      fileserveDownUrl: ''
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: () => {
        return 0;
      }
    }
  },
  watch: {
    dialogFormVisible (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },
  components: {
  },
  computed: {},
  methods: {
    initData () {
      partialInvoiceDetail({ id: this.id }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.productList;
          this.applyGoodsBaseInfo = json.data;
          this.title = json.data.deliveryNum;
          this.initFileData(json.data.deliveryNum);
        } else {

        }
      }).catch((res) => {
      });
      getApproveLogByPartialId({ partialId: this.id }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableDataHistory = json.data;
        } else {

        }
      });
    },
    initFileData (partialShipmentNum) {
      getReceiptAttachmentByPartialShipmentNum({ partialShipmentNum: partialShipmentNum }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.fileList = json.data;
        } else {

        }
      }).catch((res) => {
      });
    },
    fileClick (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },
    // 文件服务器地址
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.productNum(param.data);
        }
        // if (column.label === '实际结算金额') {
        //   sums[index] = this.settlementAmount(param.data);
        // }
      });
      return sums;
    },
    // 实际结算金额总计
    productNum (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      // cont = Number(cont).toFixed(2);
      return cont;
    },
    settlementAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    open () {
      this.initData();
    },
    handelClose () {
      this.dialogVisible = false;
    }
  },
  mounted () {
    // this.initData();
    this.initToken();
  }
};
</script>
<style scope>
.partShipment p{
  margin: 10px 0 ;
}
.partShipment p span{
  display:inline-block;
  margin-right: 10px;
}
</style>
